import React, { useEffect, useState } from "react";
import { Button } from "../../components/ui";
import CollectionForm from "./CollectionForm";

const fmt = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleString("en-GB", {
    timeZone: "Europe/London",
    weekday: "short",
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
};

/**
 * "Collection / courier" block of the request page's Order Summary card — the
 * one place every flow (order, sell, PX) shows, so collections can be booked
 * where the deal is worked. Feeds the Dashboard's `collection_due` action and
 * its What's on today strip. Admins only; needs a saved request.
 */
export default function RequestCollectionSection({ request, user }) {
  const [saved, setSaved] = useState({ at: request?.collection_at ?? null, note: request?.collection_note ?? null });
  const [editing, setEditing] = useState(false);

  useEffect(() => {
    setSaved({ at: request?.collection_at ?? null, note: request?.collection_note ?? null });
  }, [request?.id, request?.collection_at, request?.collection_note]);

  if (!request?.id || !user?.is_admin) return null;

  const when = fmt(saved.at);

  return (
    <section className="rc-request-v2__inv-section" aria-label="Collection / courier">
      <div className="rc-request-v2__inv-heading">
        <span className="rc-request-v2__inv-heading-left">
          <span>Collection / courier</span>
        </span>
        <span className="rc-request-v2__inv-heading-action">
          <Button variant="ghost" size="sm" data-btn="collection-toggle" onClick={() => setEditing((v) => !v)}>
            {editing ? "Close" : when ? "Change" : "Book"}
          </Button>
        </span>
      </div>
      {!editing ? (
        <div className="rc-request-v2__inv-row">
          <span className="rc-request-v2__inv-row-label">{when ? "Booked" : "Not booked"}</span>
          {when ? <span className="rc-request-v2__inv-row-value rc-request-v2__collection-when">{when}</span> : null}
          {saved.note ? <small className="rc-request-v2__inv-row-note">{saved.note}</small> : null}
        </div>
      ) : (
        <CollectionForm
          requestId={request.id}
          initialAt={saved.at}
          initialNote={saved.note}
          onSaved={(s) => {
            setSaved({ at: s.collection_at, note: s.collection_note });
            setEditing(false);
          }}
        />
      )}
    </section>
  );
}
